import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  ModalController,
} from '@ionic/angular/standalone';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { P00032 } from '../../../P00032';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-p0003606-detection-fin-bidon-modal',
  templateUrl: './p0003606-detection-fin-bidon-modal.component.html',
  styleUrls: ['./p0003606-detection-fin-bidon-modal.component.scss'],
  imports: [
    IonContent,
    GlobalPageHeaderComponent,
    TranslatePipe,
    IonButton,
    IonFooter,
  ],
})
export class P0003606DetectionFinBidonModalComponent implements OnInit {
  @Input() title: string = '';
  private modalController = inject(ModalController);
  private edroNetworkManager = inject(EdroNetworkManager);

  public actionsStack: DeviceActionStackService | null = null;
  public step: number = 0;
  public memValue: any = undefined;

  constructor() {}

  ngOnInit() {
    this.actionsStack = new DeviceActionStackService(
      new P00032(),
      this.edroNetworkManager,
    );
  }

  public setMemValue() {
    this.memValue = this.actionsStack!.getValue('iphSEtatContactFinBidon');
    this.step = 1;
  }
  public async setMemValue2() {
    const currentValue = this.actionsStack!.getValue('iphSEtatContactFinBidon');

    if (this.memValue === 0 && currentValue === 1) {
      await this.modalController.dismiss({
        value: 0,
      });
    } else if (this.memValue === 1 && currentValue === 0) {
      await this.modalController.dismiss({
        value: 1,
      });
    } else {
      this.step = 2;
    }
  }

  setStep(step: number) {
    this.step = step;
  }

  public async dismissModal() {
    await this.modalController.dismiss();
  }
}
